import * as actionTypes from "./actionTypes";
const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {

  switch (action.type) {
      case actionTypes.UPDATE_MOBILE_HOMEPAGE_DATA:
      return {
        ...state,
        allData: action?.payload?.data || [],
      };
    default:
      return state;
  }
};

export default reducer;

